// extracted by mini-css-extract-plugin
export default {"body":"JsonAutoComplete_body__rqrKI","tip":"JsonAutoComplete_tip__5+kIl"};